import React from "react";
import { Outlet } from "react-router-dom";

const ItemRegistrationOutlet = () => {
    return (
        <>
            <Outlet />
        </>
    )
}

export default ItemRegistrationOutlet